import * as React from "react";
import { forwardRef } from "react";
const StarSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { d: "M7.536 1.545a.5.5 0 0 1 .928 0l1.711 4.262 4.583.311a.5.5 0 0 1 .287.883L11.52 9.945l1.12 4.454a.5.5 0 0 1-.75.546L8 12.503l-3.89 2.442a.5.5 0 0 1-.75-.546l1.12-4.454L.955 7.001a.5.5 0 0 1 .287-.883l4.583-.31z" }));
const ForwardRef = forwardRef(StarSVG);
export default ForwardRef;
//# sourceMappingURL=Star.js.map